var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLimitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 133,
    viewBox: "0 0 196 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.4072 119.806C151.199 119.806 194.807 111.856 194.807 102.05C194.807 92.2429 151.199 84.293 97.4072 84.293C43.615 84.293 0.0078125 92.2429 0.0078125 102.05C0.0078125 111.856 43.615 119.806 97.4072 119.806Z",
    fill: "url(#paint0_radial_6725_52120)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8906 1H119.46L134.957 15.2053V101.728H54.8906V1Z",
    fill: "white",
    stroke: "#DDE3E6",
    strokeWidth: 0.613437,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.461 1L122.689 13.2682L134.958 15.851",
    stroke: "#DDE3E6",
    strokeWidth: 0.613437,
    strokeMiterlimit: 10
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 22.3086,
    width: 62.6325,
    height: 3.87417,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 32.6426,
    width: 30.3477,
    height: 3.87417,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 97.5,
    y: 32.6426,
    width: 12.2682,
    height: 3.87417,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 113.641,
    y: 32.6426,
    width: 12.2682,
    height: 3.87417,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 41.6816,
    width: 30.3477,
    height: 3.87417,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 97.5,
    y: 41.6816,
    width: 12.2682,
    height: 3.87417,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 113.641,
    y: 41.6816,
    width: 12.2682,
    height: 3.87417,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 50.7227,
    width: 30.3477,
    height: 3.87417,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 97.5,
    y: 50.7227,
    width: 12.2682,
    height: 3.87417,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 113.641,
    y: 50.7227,
    width: 12.2682,
    height: 3.87417,
    fill: "#D9D9D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 59.7617,
    width: 30.3477,
    height: 3.87417,
    fill: "#D9D9D9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 97.5,
    y: 59.7617,
    width: 12.2682,
    height: 3.87417,
    fill: "#D9D9D9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 113.641,
    y: 59.7617,
    width: 12.2682,
    height: 3.87417,
    fill: "#D9D9D9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 68.8027,
    width: 30.3477,
    height: 3.87417,
    fill: "#D9D9D9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 97.5,
    y: 68.8027,
    width: 12.2682,
    height: 3.87417,
    fill: "#D9D9D9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 113.641,
    y: 68.8027,
    width: 12.2682,
    height: 3.87417,
    fill: "#D9D9D9"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 63.2812,
    y: 77.8418,
    width: 30.3477,
    height: 3.87417,
    fill: "#D9D9D9"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 97.5,
    y: 77.8418,
    width: 12.2682,
    height: 3.87417,
    fill: "#D9D9D9"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 113.641,
    y: 77.8418,
    width: 12.2682,
    height: 3.87417,
    fill: "#D9D9D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M126.756 67.5059C112.329 67.5059 100.633 79.2139 100.633 93.6565C100.633 108.099 112.329 119.807 126.756 119.807C141.184 119.807 152.88 108.099 152.88 93.6565C152.88 79.2139 141.184 67.5059 126.756 67.5059Z",
    fill: "#FF0000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.661 97.4443C132.661 99.0258 132.142 100.248 131.103 101.111C130.065 101.973 128.587 102.404 126.67 102.404C124.857 102.404 123.416 101.989 122.345 101.158C121.275 100.32 120.648 99.1136 120.464 97.5401L123.891 97.2406C124.106 98.862 125.029 99.6728 126.658 99.6728C127.465 99.6728 128.092 99.4731 128.54 99.0737C128.987 98.6743 129.21 98.0633 129.21 97.2406C129.21 96.4898 128.939 95.9147 128.396 95.5153C127.853 95.1159 127.046 94.9162 125.976 94.9162H124.801V92.1965H125.904C126.87 92.1965 127.597 92.0008 128.084 91.6094C128.571 91.21 128.815 90.6429 128.815 89.9081C128.815 89.2132 128.619 88.67 128.228 88.2786C127.845 87.8793 127.281 87.6796 126.539 87.6796C125.844 87.6796 125.281 87.8713 124.849 88.2547C124.426 88.6381 124.182 89.1812 124.118 89.8841L120.752 89.6445C120.927 88.1908 121.531 87.0526 122.561 86.2299C123.591 85.4071 124.937 84.9958 126.599 84.9958C128.364 84.9958 129.742 85.3952 130.732 86.1939C131.731 86.9847 132.23 88.0829 132.23 89.4887C132.23 90.5431 131.918 91.4097 131.295 92.0887C130.68 92.7676 129.79 93.2189 128.623 93.4425V93.4905C129.917 93.6422 130.912 94.0696 131.607 94.7724C132.31 95.4674 132.661 96.358 132.661 97.4443Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M145.241 75.4492C155.346 85.5541 155.354 101.929 145.26 112.023M151.117 69.5739C164.471 82.9273 164.482 104.566 151.142 117.906M156.801 63.8875C173.296 80.3832 173.31 107.114 156.831 123.593M162.589 58.1015C182.284 77.7968 182.301 109.713 162.626 129.388",
    stroke: "#FF0000",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M108.267 75.4492C98.162 85.5541 98.1536 101.929 108.248 112.023M102.391 69.5739C89.0372 82.9273 89.026 104.566 102.366 117.906M96.7072 63.8875C80.2115 80.3832 80.1977 107.114 96.6764 123.593M90.9186 58.1015C71.2233 77.7968 71.2068 109.713 90.8818 129.388",
    stroke: "#FF0000",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6725_52120",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.4072 102.049) scale(90.6295 15.674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE3E6",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitIcon);
export default __webpack_public_path__ + "static/media/limit_icon.7d66e941205b48ef105b57ffd7b5ed59.svg";
export { ForwardRef as ReactComponent };